import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Api from "../../api/api";

const Update = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    validity_days: "",
    sell_price: "",
    original_price: "",
    expiry_date: "",
    allowed_number_of_devices: "",
    status: "",
    description: "",
  });

  useEffect(() => {
    if (location.state) {
      setFormData({
        name: location.state.name || "",
        validity_days: location.state.validity_days || "",
        sell_price: location.state.sell_price || "",
        original_price: location.state.original_price || "",
        expiry_date: location.state.expiry_date || "",
        allowed_number_of_devices: location.state.allowed_number_of_devices || "",
        status: location.state.status || "",
        description: location.state.description || "",
      });
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");
      await Api.updateSubscription(id, formData, token);
      Swal.fire("Success", "Subscription updated successfully!", "success");
      navigate("/subscription", { state: { refresh: true } });
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      Swal.fire("Error", error.response?.data?.message || "Failed to update subscription.", "error");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "600px",
          padding: "2rem",
          border: "1px solid #ccc",
          borderRadius: "10px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem", textAlign: "center", color: "#333" }}>
          Update Subscription
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
        >

          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="Subscription Name"
              />
            </div>

            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="validity_days">Validity Days</label>
              <input
                id="validity_days"
                type="number"
                name="validity_days"
                value={formData.validity_days}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="Number of Days"
                min="1"
              />
            </div>
          </div>

          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="sell_price">Sell Price</label>
              <input
                id="sell_price"
                type="number"
                name="sell_price"
                value={formData.sell_price}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="Enter sell price"
                min="0"
                step="0.01"
              />
            </div>

            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="original_price">Original Price</label>
              <input
                id="original_price"
                type="number"
                name="original_price"
                value={formData.original_price}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="Enter original price"
                min="0"
                step="0.01"
              />
            </div>
          </div>

          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="expiry_date">Expiry Date</label>
              <input
                id="expiry_date"
                type="date"
                name="expiry_date"
                value={formData.expiry_date}
                onChange={handleChange}
                required
                style={inputStyle}
              />
            </div>

            <div style={{ flex: 1, minWidth: "200px" }}>
              <label htmlFor="allowed_number_of_devices">Allowed Devices</label>
              <input
                id="allowed_number_of_devices"
                type="number"
                name="allowed_number_of_devices"
                value={formData.allowed_number_of_devices}
                onChange={handleChange}
                required
                style={inputStyle}
                min="1"
              />

            </div>
          </div>

          <div>
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>

          <div>
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              required
              style={{ ...inputStyle, resize: "vertical" }}
              placeholder="Add description here..."
            />
          </div>

          <button
            type="submit"
            style={buttonStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            Update Subscription
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "1rem",
  transition: "border-color 0.3s",
  outline: "none",
};

const buttonStyle = {
  padding: "12px 20px",
  borderRadius: "8px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  fontSize: "1rem",
  fontWeight: "600",
  cursor: "pointer",
  transition: "background-color 0.3s",
};

inputStyle[":focus"] = {
  borderColor: "#007bff",
  boxShadow: "0 0 5px rgba(0, 123, 255, 0.5)",
};

export default Update;
